export enum MediaTypes {
	IMAGE = 0,
	VIDEO = 1,
	CAROUSEL_ALBUM = 2,
}
